// ConsoleHome.jsx
// TK 6/28/2022

// Packages, dependencies, and library functions
import React from "react";
import { useNavigate } from "react-router-dom";

// React Components
import HomePageHeader from "./ConsoleHomePageHeader";

const ConsoleHome = () => {
  // Constants
  const navigate = useNavigate();

  return (
    <div>
      <HomePageHeader />
      <div className="container">
        <div
          className="item"
          onClick={() => {
            navigate("v2");
          }}
        >
          ✨ Console V2
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("planteditor");
          }}
        >
          Plant Editor
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("plantgeneration");
          }}
        >
          Plant Generation
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("analytics");
          }}
        >
          Analytics
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("analyticsv2");
          }}
        >
          Analytics V2
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("campaigns");
          }}
        >
          Campaign Analytics
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("taggeneration");
          }}
        >
          Tag Generation
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("promotags");
          }}
        >
          Promo QR PDFs
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("careinstructionsupload");
          }}
        >
          Care Instructions Upload
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("speciesinfoupload");
          }}
        >
          Species Info Upload
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("speciestraitsupload");
          }}
        >
          Species Traits Upload
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("spriteupload");
          }}
        >
          Sprite Upload
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("plantwaterreset");
          }}
        >
          Plant Water Reset
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("speciesregeneration");
          }}
        >
          Species Regeneration
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("userplants");
          }}
        >
          User Plants
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("speciesownercounts");
          }}
        >
          Species Owner Counts
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("chatv2tester");
          }}
        >
          Chat V2 Tester
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("conversations");
          }}
        >
          Plant Conversations
        </div>
        <div
          className="item"
          onClick={() => {
            navigate("snailsforce");
          }}
        >
          Snailsforce CRM
        </div>
      </div>
    </div>
  );
};

export default ConsoleHome;
